
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Punestationtonavimumbaiairport() {



const cardData = {
  keyword: "Pune Station to Navi Mumbai Airport Cab  ",
  heading: "Skyline Cabs: Pune Station to Navi Mumbai Airport Cab  ",
  headingDescription: "Skyline Cabs provides reliable and professionally managed Pune Station to Navi Mumbai International Airport Cab services for corporate travelers, business executives, families, and long-distance airport passengers. Whether you are arriving at or departing from Pune Railway Station, we ensure smooth and efficient expressway connectivity to Navi Mumbai International Airport. Our fleet includes well-maintained AC sedans, spacious SUVs, and premium vehicles suitable for comfortable and luggage-friendly long-distance travel. With experienced chauffeurs, punctual pickup coordination aligned with train schedules, transparent fare structure, and 24x7 availability, Skyline Cabs ensures safe, stress-free, and on-time airport transfers from Pune Station to Navi Mumbai International Airport. 🚖.",

  top: "Top Places to visit in Navi Mumbai with skyline Cab",

 topPlaces: [
  {
    title: "Palm Beach Road",
    description: "Palm Beach Road is one of the most scenic stretches in Navi Mumbai offering wide lanes, sea views, and smooth connectivity between Vashi, Nerul, and Belapur. Travelers heading toward Chhatrapati Shivaji Maharaj International Airport or Navi Mumbai International Airport enjoy this peaceful coastal drive. The well-planned infrastructure and skyline views make it ideal for business and residential access."
  },
  {
    title: "Central Park Kharghar",
    description: "Central Park in Kharghar is one of the largest urban parks in India, offering jogging tracks, musical fountains, gardens, and open green spaces. It is a perfect relaxation spot for families and professionals looking to unwind after travel or work commitments."
  },
  {
    title: "Pandavkada Waterfalls",
    description: "Pandavkada Waterfalls in Kharghar is a popular monsoon attraction known for its natural beauty and serene surroundings. Visitors from across Mumbai and nearby areas come here for short weekend trips and scenic photography."
  },
  {
    title: "Seawoods Grand Central Mall",
    description: "Seawoods Grand Central Mall is a premium shopping and entertainment destination featuring international brands, fine dining restaurants, and multiplex cinemas. Its proximity to major railway stations and business hubs makes it a convenient stop for travelers."
  },
  {
    title: "Nerul Balaji Temple",
    description: "Nerul Balaji Temple is a beautifully designed hilltop temple inspired by the Tirupati Balaji Temple. It offers peaceful surroundings, impressive architecture, and panoramic city views, attracting devotees and tourists alike."
  },
  {
    title: "Belapur Fort",
    description: "Belapur Fort is a historic structure built during the 16th century, offering trekking trails and scenic views of the surrounding creek areas. It is a favorite destination for history enthusiasts and adventure seekers."
  },
  {
    title: "DY Patil Stadium",
    description: "DY Patil Stadium in Nerul is a world-class sports venue that hosts IPL matches, concerts, and major events. Its modern infrastructure makes it one of the prominent landmarks in Navi Mumbai."
  },
  {
    title: "Kharghar Hills",
    description: "Kharghar Hills is a popular trekking and sunrise viewpoint destination offering panoramic views of Navi Mumbai. Nature lovers and fitness enthusiasts frequently visit for early morning hikes."
  },
  {
    title: "Wonders Park Nerul",
    description: "Wonders Park in Nerul is a family-friendly attraction featuring miniature replicas of the Seven Wonders of the World along with landscaped gardens and play areas for children."
  },
  {
    title: "Vashi Creek",
    description: "Vashi Creek is known for its beautiful sunset views and peaceful waterfront atmosphere. It serves as a scenic gateway connecting Mumbai and Navi Mumbai, attracting photographers and evening walkers."
  }
],

 services: [
  {
    name: "Pune Station to Navi Mumbai Airport Cab",
    description: "Skyline Cabs provides dependable Pune Station to Navi Mumbai Airport Cab service designed for seamless intercity airport transfers. Our vehicles are well-maintained, air-conditioned, and suitable for long-distance expressway travel with adequate luggage capacity. Professional chauffeurs coordinate timely pickups from Pune Railway Station arrival gates while monitoring train schedules and traffic conditions. We plan departure timing carefully to ensure punctual airport drop-offs without last-minute delays. With transparent pricing, structured booking management, and safe highway driving standards, we deliver reliable airport connectivity for business and leisure travelers."
  },
  {
    name: "Pune Railway Station to Navi Mumbai Airport Cab",
    description: "Pune Railway Station to Navi Mumbai Airport Cab service ensures smooth airport transfers with professional chauffeur support and optimized route planning. Skyline Cabs provides clean, comfortable vehicles designed for highway performance and passenger convenience. Drivers coordinate pickup from designated station points and plan departures considering city congestion and expressway traffic updates. We align travel schedules with flight departure timing for punctual airport arrival. Transparent fare policies, disciplined driving standards, and structured coordination guarantee a stress-free travel experience."
  },
  {
    name: "Pune Station to Navi Mumbai Airport Taxi",
    description: "Pune Station to Navi Mumbai Airport Taxi service offers efficient and comfortable airport transportation with experienced long-route drivers. Our air-conditioned taxis provide spacious seating and sufficient luggage space for individual and family travelers. Chauffeurs carefully manage pickup timing from Pune Station platforms and parking zones to avoid delays. We monitor Pune–Mumbai highway traffic to select optimized routes for uninterrupted transit. Clear pricing structure and professional service execution ensure dependable airport connectivity."
  },
  {
    name: "Pune Railway Station to Navi Mumbai Airport Taxi",
    description: "Skyline Cabs delivers professional Pune Railway Station to Navi Mumbai Airport Taxi service tailored for punctual airport transfers. Vehicles are sanitized, well-maintained, and equipped for comfortable expressway travel. Drivers monitor train arrival schedules and coordinate pickup timing accordingly for smooth departures. We carefully plan routing through city traffic and highway corridors to ensure timely airport drop-offs. Transparent fare breakdown and safe driving standards define our reliable taxi service."
  },
  {
    name: "Pune Junction to Navi Mumbai Airport Cab",
    description: "Pune Junction to Navi Mumbai Airport Cab service provides structured airport transfer planning with experienced chauffeurs and comfortable vehicles. Skyline Cabs ensures timely pickup from Pune Junction entry and exit points with efficient route selection. Our vehicles are optimized for long-distance expressway connectivity with adequate luggage capacity. Departure timing is aligned with flight schedules to prevent travel disruptions. Transparent billing policies and disciplined highway driving standards guarantee dependable airport transfers."
  },
  {
    name: "Pune Railway Station Taxi to Navi Mumbai Airport",
    description: "Pune Railway Station Taxi to Navi Mumbai Airport service offers smooth intercity connectivity supported by professional drivers and reliable vehicles. Skyline Cabs ensures convenient pickup from station zones with clear communication and punctual coordination. Our taxis are air-conditioned and maintained for comfortable long-route travel. Traffic conditions are monitored in real-time to optimize routing and maintain airport arrival timing. Structured booking confirmation and transparent pricing provide consistent travel assurance."
  },
  {
    name: "Shivajinagar Station to Navi Mumbai Airport Cab",
    description: "Shivajinagar Station to Navi Mumbai Airport Cab service ensures reliable airport transfers for passengers arriving at Shivajinagar railway point. Vehicles are clean, comfortable, and designed for smooth highway travel with adequate luggage handling space. Professional chauffeurs monitor local traffic and expressway conditions to ensure timely departures. We coordinate flight schedules carefully to guarantee punctual airport drop-offs. Transparent fare structure and disciplined service management ensure safe and dependable connectivity."
  },
  {
    name: "Pune Station Airport Taxi Navi Mumbai",
    description: "Pune Station Airport Taxi Navi Mumbai service delivers convenient airport transportation with structured pickup coordination and optimized highway routing. Skyline Cabs provides well-maintained vehicles suitable for long-distance travel comfort. Drivers ensure punctual arrival at the station and manage departures considering traffic patterns. We align travel schedules with airport reporting time to avoid delays. Transparent pricing and safe driving practices define our professional airport taxi solutions."
  },
  {
    name: "Cab from Pune Station to Navi Mumbai Airport",
    description: "Cab from Pune Station to Navi Mumbai Airport service ensures dependable expressway travel with experienced chauffeurs and comfortable vehicles. Skyline Cabs coordinates timely pickup directly from station entry points with organized travel planning. Our fleet supports luggage-friendly seating and air-conditioned comfort for smooth intercity connectivity. Traffic monitoring and route optimization guarantee punctual airport arrival. Transparent fare policies and structured booking management provide consistent service reliability."
  },
  {
    name: "Pune Station to Navi Mumbai Airport Drop Cab",
    description: "Pune Station to Navi Mumbai Airport Drop Cab service is structured for efficient one-way airport transfers with clear fixed pricing. Skyline Cabs ensures punctual pickup from railway station premises and optimized routing via expressway corridors. Vehicles are sanitized, comfortable, and suitable for long-distance travel with sufficient baggage space. We coordinate departure timing according to flight schedules to ensure smooth airport drop-offs. Transparent billing and disciplined service execution guarantee dependable travel."
  },
  {
    name: "Innova Crysta Pune Station to Navi Mumbai Airport",
    description: "Innova Crysta Pune Station to Navi Mumbai Airport service offers premium and spacious airport transfers ideal for families and corporate executives. The vehicle provides superior seating comfort, large luggage capacity, and smooth highway performance. Professional chauffeurs manage timely station pickup and optimized departure coordination. We align travel timing with flight schedules and monitor traffic flow to ensure punctual arrival. Transparent pricing and structured booking ensure a premium airport experience."
  },
  {
    name: "Ertiga Cab Pune Station to Navi Mumbai Airport",
    description: "Ertiga Cab Pune Station to Navi Mumbai Airport service delivers economical yet comfortable airport connectivity for small groups and business travelers. The vehicle ensures balanced seating and adequate luggage space for smooth expressway travel. Drivers coordinate timely pickup from Pune Station and monitor traffic updates for efficient routing. Departure timing is aligned with airport reporting schedules for punctual arrival. Clear pricing structure and professional standards guarantee reliable transfers."
  },
  {
    name: "Sedan Cab Pune Station to Navi Mumbai Airport",
    description: "Sedan Cab Pune Station to Navi Mumbai Airport service provides cost-effective and efficient airport transportation for solo and corporate travelers. Air-conditioned sedans ensure comfortable seating and reliable highway performance. Chauffeurs plan timely station pickup and optimized routing for smooth intercity connectivity. Traffic monitoring and departure scheduling ensure punctual airport drop-offs. Transparent billing and disciplined driving standards maintain consistent service quality."
  },
  {
    name: "SUV Cab Pune Station to Navi Mumbai Airport",
    description: "SUV Cab Pune Station to Navi Mumbai Airport service offers spacious and comfortable airport travel suitable for families and group passengers. The vehicle category ensures higher seating comfort, enhanced luggage capacity, and stable expressway performance. Professional drivers coordinate punctual station pickup and strategic departure timing. We align airport arrival schedules with flight timing to avoid disruptions. Transparent pricing and safety-focused service standards ensure dependable transfers."
  },
  {
    name: "Pune Station to Navi Mumbai Airport Cab Booking",
    description: "Pune Station to Navi Mumbai Airport Cab Booking service provides convenient advance reservation with structured confirmation and reliable vehicle allocation. Skyline Cabs ensures availability of sedan, SUV, and premium options for airport travel needs. Drivers maintain punctual pickup from railway station areas with optimized routing. Departure scheduling is aligned with airport reporting time for smooth travel. Transparent pricing and professional coordination deliver stress-free booking experiences."
  },
  {
    name: "Pune Station to Navi Mumbai Airport One Way Cab",
    description: "Pune Station to Navi Mumbai Airport One Way Cab service offers economical and fixed-rate airport transfers without return fare charges. Skyline Cabs ensures timely pickup from station premises and efficient highway navigation. Vehicles are clean, comfortable, and designed for smooth long-distance connectivity. We monitor traffic flow and coordinate departure timing carefully to maintain punctual airport arrival. Transparent billing structure and disciplined service management guarantee reliable one-way transfers."
  },
  {
    name: "Pune Station to Navi Mumbai Airport Pickup & Drop",
    description: "Pune Station to Navi Mumbai Airport Pickup & Drop service provides complete round-trip airport transfer solutions with professional coordination. Skyline Cabs ensures punctual pickup from station arrival zones and safe expressway travel. Vehicles are well-maintained and suitable for comfortable intercity journeys with sufficient baggage space. Flight schedule tracking and traffic monitoring help maintain timely airport transfers. Transparent fare structure and structured service execution ensure dependable pickup and drop arrangements."
  }
],

tableData: [
  ["Pune Station to Navi Mumbai Airport Cab", "Pune Railway Station to Navi Mumbai Airport Cab"],
  ["Pune Station to Navi Mumbai Airport Taxi", "Pune Railway Station to Navi Mumbai Airport Taxi"],
  ["Pune Junction to Navi Mumbai Airport Cab", "Pune Railway Station Taxi to Navi Mumbai Airport"],
  ["Shivajinagar Station to Navi Mumbai Airport Cab", "Pune Station Airport Taxi Navi Mumbai"],
  ["Cab from Pune Station to Navi Mumbai Airport", "Pune Station to Navi Mumbai Airport Drop Cab"],
  ["Innova Crysta Pune Station to Navi Mumbai Airport", "Ertiga Cab Pune Station to Navi Mumbai Airport"],
  ["Sedan Cab Pune Station to Navi Mumbai Airport", "SUV Cab Pune Station to Navi Mumbai Airport"],
  ["Pune Station to Navi Mumbai Airport Cab Booking", "Pune Station to Navi Mumbai Airport One Way Cab"],
  ["Pune Station to Navi Mumbai Airport Pickup & Drop", ""]
],

whychoose: [
  {
    WhyChooseheading: "Pune Station Pickup Expertise",
    WhyChoosedescription: "Skyline Cab specializes in convenient pickups from Pune Railway Station, ensuring smooth coordination even during peak train arrival hours. Our drivers are familiar with platform-side exits, parking zones, and traffic flow around the station area, allowing quick passenger pickup without confusion or long waiting times. Whether you arrive early morning or late at night, we track your train schedule when required and adjust pickup timing accordingly, making your transfer from Pune Station to Navi Mumbai Airport seamless and stress-free."
  },
  {
    WhyChooseheading: "Experienced Expressway Chauffeurs",
    WhyChoosedescription: "Our professional drivers are highly experienced in handling long-distance routes via the Pune–Mumbai Expressway, ensuring a safe, stable, and comfortable journey. They follow disciplined highway driving practices, maintain optimal speeds, and prioritize passenger safety throughout the trip. With strong knowledge of toll routes, alternative diversions, and live traffic updates, Skyline Cab ensures a time-efficient transfer from Pune Station to Navi Mumbai Airport."
  },
  {
    WhyChooseheading: "Guaranteed Timely Airport Arrival",
    WhyChoosedescription: "We understand that airport transfers demand strict punctuality. Skyline Cab carefully calculates travel time by considering traffic density, peak hours, and airport reporting guidelines before scheduling your ride. Our structured pickup planning ensures that you reach Navi Mumbai Airport well in advance for check-in and security clearance, giving you peace of mind and eliminating last-minute travel anxiety."
  },
  {
    WhyChooseheading: "Transparent and All-Inclusive Pricing",
    WhyChoosedescription: "With Skyline Cab, you receive a clear and upfront fare quote for your Pune Station to Navi Mumbai Airport transfer. Our pricing policy includes toll charges, driver allowance, and applicable taxes without hidden surprises. This transparent fare structure helps customers plan their travel budget confidently while enjoying reliable and premium airport cab service."
  },
  {
    WhyChooseheading: "24x7 Availability for All Train Arrivals",
    WhyChoosedescription: "Trains often arrive at odd hours, and Skyline Cab operates round-the-clock to match your schedule. Whether your train reaches Pune Station at midnight, early dawn, or during busy daytime hours, our airport cabs are readily available. Our support team stays active 24/7 to coordinate driver details and ensure smooth pickup and drop-off at Navi Mumbai Airport."
  },
  {
    WhyChooseheading: "Comfortable AC Vehicles for Long-Distance Travel",
    WhyChoosedescription: "Our fleet consists of well-maintained, air-conditioned vehicles designed for intercity comfort. Spacious seating, clean interiors, and ample luggage space make Skyline Cab ideal for travelers carrying heavy suitcases from railway journeys. Every vehicle is regularly sanitized and inspected to provide a safe and pleasant ride experience all the way to Navi Mumbai Airport."
  },
  {
    WhyChooseheading: "Ideal for Family and Corporate Transfers",
    WhyChoosedescription: "Skyline Cab caters to families, solo travelers, and corporate professionals needing reliable airport transportation from Pune Station. Our drivers maintain professional conduct and assist with luggage handling to ensure a smooth experience. For business travelers heading to important meetings or international flights, we offer punctual, quiet, and comfortable rides tailored to executive travel standards."
  },
  {
    WhyChooseheading: "Dedicated Trip Coordination Support",
    WhyChoosedescription: "From the moment you book until you reach Navi Mumbai Airport, our support team actively monitors your trip for smooth coordination. We provide driver contact details, real-time updates, and responsive assistance in case of schedule changes. Skyline Cab focuses on delivering dependable, hassle-free airport transfers so you can travel with complete confidence."
  }
]


}

const faqData = [
    {
        id: 1,
        question: 'How can I book Hadapsar to Navi Mumbai Airport Cab with Skyline Cabs?',
        answer:
            'Booking Hadapsar to Navi Mumbai Airport Cab with Skyline Cabs is simple, fast, and reliable. You can visit our website or mobile app, enter Hadapsar as your pickup location and Navi Mumbai Airport as your drop destination, select your preferred vehicle, and confirm instantly. After booking, you receive complete trip confirmation along with driver and vehicle details. Our streamlined booking system ensures a smooth airport transfer experience without last-minute hassle.',
    },
    {
        id: 2,
        question: 'Is Hadapsar to Navi Mumbai Airport Cab service available 24/7?',
        answer:
            'Yes, Skyline Cabs provides 24/7 Hadapsar to Navi Mumbai Airport Cab service for both early morning and late-night flights. Whether you are traveling from Magarpatta, Amanora, or nearby areas in Hadapsar, our professional drivers ensure punctual pickup and timely airport drop. We understand the importance of flight schedules and guarantee reliable airport transfers at any hour.',
    },
    {
        id: 3,
        question: 'What vehicle options are available for Hadapsar to Navi Mumbai Airport Cab?',
        answer:
            'We offer multiple vehicle options including Swift Dzire, Ertiga, Innova Crysta, and premium SUVs for Hadapsar to Navi Mumbai Airport Cab bookings. You can choose a budget-friendly sedan for solo travel or a spacious SUV for family and group transfers. All vehicles are well-maintained, sanitized, air-conditioned, and driven by experienced chauffeurs for maximum comfort.',
    },
    {
        id: 4,
        question: 'How much is the Hadapsar to Navi Mumbai Airport Cab fare?',
        answer:
            'The Hadapsar to Navi Mumbai Airport Cab fare depends on the vehicle type and travel date. Skyline Cabs follows a transparent pricing policy where the total fare is shown before booking confirmation. The price includes driver allowance and applicable charges, ensuring there are no hidden costs or surprise payments.',
    },
    {
        id: 5,
        question: 'Is one-way Hadapsar to Navi Mumbai Airport Cab available?',
        answer:
            'Yes, Skyline Cabs offers affordable one-way Hadapsar to Navi Mumbai Airport Cab service. You only pay for the distance traveled without return fare charges. This makes it convenient and economical for airport drops and single-direction travel needs.',
    },
    {
        id: 6,
        question: 'How long does it take to travel from Hadapsar to Navi Mumbai Airport by cab?',
        answer:
            'The journey from Hadapsar to Navi Mumbai Airport typically takes around 2.5 to 3.5 hours depending on traffic and time of travel. Our experienced drivers select the best highway routes to ensure smooth and comfortable long-distance travel.',
    },
    {
        id: 7,
        question: 'Is online payment available for Hadapsar to Navi Mumbai Airport Cab booking?',
        answer:
            'Yes, Skyline Cabs supports secure online payments including UPI, credit cards, debit cards, and net banking. Once your payment is completed, you receive instant confirmation along with trip and driver details for complete peace of mind.',
    },
    {
        id: 8,
        question: 'Can I pre-book Hadapsar to Navi Mumbai Airport Cab in advance?',
        answer:
            'Absolutely. You can pre-book your Hadapsar to Navi Mumbai Airport Cab for any future date and time. Advance booking ensures guaranteed vehicle availability, especially during peak travel seasons, holidays, and corporate travel rush.',
    },
    {
        id: 9,
        question: 'Is Hadapsar to Navi Mumbai Airport Cab suitable for family and corporate travel?',
        answer:
            'Yes, our Hadapsar to Navi Mumbai Airport Cab service is ideal for both family and corporate travel. Spacious vehicles, comfortable seating, ample luggage space, and professional drivers ensure a relaxed and stress-free airport transfer experience.',
    },
    {
        id: 10,
        question: 'Why choose Skyline Cabs for Hadapsar to Navi Mumbai Airport Cab?',
        answer:
            'Skyline Cabs is trusted for Hadapsar to Navi Mumbai Airport Cab service because of our punctual pickups, experienced chauffeurs, clean and comfortable vehicles, transparent pricing, and 24x7 customer support. We focus on delivering safe, reliable, and smooth airport transfers every time.',
    },
];

const someReviews = [
    {
        name: "Mr. Sachin More",
        rating: 5,
        review: "Booked Hadapsar to Navi Mumbai Airport Cab with Skyline Cabs for early morning flight. Driver was on time, vehicle was clean, and the ride was smooth. Highly reliable airport transfer service!"
    },
    {
        name: "Mrs. Kavita Sharma",
        rating: 4,
        review: "Very dependable Hadapsar to Navi Mumbai Airport Cab service. Transparent pricing and comfortable vehicle made our journey stress-free. Skyline Cabs provides excellent and professional service."
    },
];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



      
    
      
const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Station to Navi Mumbai Airport Cab",
  "image": "https://skylinecabs.com/assets/images/pune-station-to-navi-mumbai-airport-cab.jpg",
  "description": "Book Pune Station to Navi Mumbai Airport Cab with Skyline Cabs for comfortable, safe, and timely airport transfers. AC, Innova Crysta, Ertiga, Sedan, and SUV cabs available from Pune Railway Station, Pune Junction, Shivajinagar Station, and surrounding areas with professional drivers at affordable fares.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8043"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2399",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/pune-station-to-navi-mumbai-airport-cab"
  }
};



    return (
        <div>

<Helmet>
  <title>Pune Station to Navi Mumbai Airport Cab | AC Pickup & Drop | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Pune Station to Navi Mumbai Airport Cab with Skyline Cabs for safe, comfortable, and timely airport transfers. AC, Innova Crysta, Ertiga, Sedan, and SUV cabs available from Pune Railway Station, Pune Junction, and Shivajinagar Station." 
  />
  <meta 
    name="keywords" 
    content="Pune Station to Navi Mumbai Airport Cab, Pune Railway Station to Navi Mumbai Airport Cab, Pune Station to Navi Mumbai Airport Taxi, Pune Railway Station to Navi Mumbai Airport Taxi, Pune Junction to Navi Mumbai Airport Cab, Pune Railway Station Taxi to Navi Mumbai Airport, Shivajinagar Station to Navi Mumbai Airport Cab, Pune Station Airport Taxi Navi Mumbai, Cab from Pune Station to Navi Mumbai Airport, Pune Station to Navi Mumbai Airport Drop Cab, Innova Crysta Pune Station to Navi Mumbai Airport, Ertiga Cab Pune Station to Navi Mumbai Airport, Sedan Cab Pune Station to Navi Mumbai Airport, SUV Cab Pune Station to Navi Mumbai Airport, Pune Station to Navi Mumbai Airport Cab Booking, Skyline Cabs Pune Station to Navi Mumbai Airport" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/139.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punestationtonavimumbaiairport;